module.exports = __webpack_public_path__ + "img/bicycleRearLeft.0f3e743d.svg";